"use strict";

exports.__esModule = true;
exports.ARCHIVE_PARAMS = void 0;
var ARCHIVE_PARAMS = {
  showNewestPostsFirst: {
    wixParam: 'showNewestPostsFirst',
    appSettingsPath: 'style.booleans.showNewestPostsFirst',
    defaultValue: true
  },
  showPostCount: {
    wixParam: 'showPostCount',
    appSettingsPath: 'style.booleans.showPostCount',
    defaultValue: true
  },
  monthsDisplayLimit: {
    wixParam: 'monthsDisplayLimit',
    appSettingsPath: 'style.numbers.monthsDisplayLimit',
    defaultValue: 12,
    minValue: 1,
    maxValue: 50
  }
};
exports.ARCHIVE_PARAMS = ARCHIVE_PARAMS;